import { DASHBOARD } from "./types"

const initialState = {
  stats: null,
  applicantsStatus: null,
  applicantsReport: null,
  totalJobsAndApplicant: null,
  totalApplicantsReports: null,
  openJobByCategory: null,
  totalApplicantsFunnel: null,
  applicationsReceivedByCategory: null,
  jobPostByJobType: null,
  jobAcceptedRatio: null,
  jobByTitle: null,
  locationData: null,
  applicantByGender: null,

  statsLoading: false,
  applicantsStatusLoading: false,
  applicantsReportLoading: false,
  totalJobsAndApplicantLoading: false,
  totalApplicantsReportsLoading: false,
  openJobByCategoryLoading: false,
  totalApplicantsFunnelLoading: false,
  applicationsReceivedByCategoryLoading: false,
  jobPostByJobTypeLoading: false,
  jobAcceptedRatioLoading: false,
  jobByTitleLoading: false,
  locationDataLoading: false,
  applicantByGenderLoading: false,

  error: null
}

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case DASHBOARD.GET_STATS_REQUEST:
      return { ...state, statsLoading: true }
    case DASHBOARD.GET_APPLICANTS_STATUS_REQUEST:
      return { ...state, applicantsStatusLoading: true }
    case DASHBOARD.GET_APPLICANTS_REPORT_REQUEST:
      return { ...state, applicantsReportLoading: true }
    case DASHBOARD.GET_TOTAL_JOBS_AND_APPLICANT_REQUEST:
      return { ...state, totalJobsAndApplicantLoading: true }
    case DASHBOARD.GET_TOTAL_APPLICANTS_REPORTS_REQUEST:
      return { ...state, totalApplicantsReportsLoading: true }
    case DASHBOARD.GET_OPEN_JOB_BY_CATEGORY_REQUEST:
      return { ...state, openJobByCategoryLoading: true }
    case DASHBOARD.GET_TOTAL_APPLICANTS_FUNNEL_REQUEST:
      return {
        ...state,
        totalApplicantsFunnelLoading: true
      }
    case DASHBOARD.GET_APPLICATIONS_RECEIVED_BY_CATEGORY_REQUEST:
      return {
        ...state,
        applicationsReceivedByCategoryLoading: true
      }
    case DASHBOARD.GET_JOB_POST_BY_JOB_TYPE_REQUEST:
      return {
        ...state,
        jobPostByJobTypeLoading: true
      }
    case DASHBOARD.GET_JOB_ACCEPTED_RATIO_REQUEST:
      return {
        ...state,
        jobAcceptedRatioLoading: true
      }
    case DASHBOARD.GET_JOB_BY_TITLE_REQUEST:
      return {
        ...state,
        jobByTitleLoading: true
      }
    case DASHBOARD.GET_LOCATION_DATA_REQUEST:
      return {
        ...state,
        locationDataLoading: true
      }
    case DASHBOARD.GET_APPLICANT_BY_GENDER_REQUEST:
      return {
        ...state,
        applicantByGenderLoading: true
      }

    case DASHBOARD.GET_STATS_SUCCESS:
      return { ...state, statsLoading: false, stats: action.payload }
    case DASHBOARD.GET_APPLICANTS_STATUS_SUCCESS:
      return {
        ...state,
        applicantsStatusLoading: false,
        applicantsStatus: action.payload
      }
    case DASHBOARD.GET_APPLICANTS_REPORT_SUCCESS:
      return {
        ...state,
        applicantsReportLoading: false,
        applicantsReport: action.payload
      }
    case DASHBOARD.GET_TOTAL_JOBS_AND_APPLICANT_SUCCESS:
      return {
        ...state,
        totalJobsAndApplicantLoading: false,
        totalJobsAndApplicant: action.payload
      }
    case DASHBOARD.GET_TOTAL_APPLICANTS_REPORTS_SUCCESS:
      return {
        ...state,
        totalApplicantsReportsLoading: false,
        totalApplicantsReports: action.payload
      }
    case DASHBOARD.GET_OPEN_JOB_BY_CATEGORY_SUCCESS:
      return {
        ...state,
        openJobByCategoryLoading: false,
        openJobByCategory: action.payload
      }
    case DASHBOARD.GET_TOTAL_APPLICANTS_FUNNEL_SUCCESS:
      return {
        ...state,
        totalApplicantsFunnelLoading: false,
        totalApplicantsFunnel: action.payload
      }
    case DASHBOARD.GET_APPLICATIONS_RECEIVED_BY_CATEGORY_SUCCESS:
      return {
        ...state,
        applicationsReceivedByCategoryLoading: false,
        applicationsReceivedByCategory: action.payload
      }
    case DASHBOARD.GET_JOB_POST_BY_JOB_TYPE_SUCCESS:
      return {
        ...state,
        jobPostByJobTypeLoading: false,
        jobPostByJobType: action.payload
      }
    case DASHBOARD.GET_JOB_ACCEPTED_RATIO_SUCCESS:
      return {
        ...state,
        jobAcceptedRatioLoading: false,
        jobAcceptedRatio: action.payload
      }
    case DASHBOARD.GET_JOB_BY_TITLE_SUCCESS:
      return {
        ...state,
        jobByTitleLoading: false,
        jobByTitle: action.payload
      }
    case DASHBOARD.GET_LOCATION_DATA_SUCCESS:
      return {
        ...state,
        locationDataLoading: false,
        locationData: action.payload
      }
    case DASHBOARD.GET_APPLICANT_BY_GENDER_SUCCESS:
      return {
        ...state,
        applicantByGenderLoading: false,
        applicantByGender: action.payload
      }

    case DASHBOARD.GET_STATS_FAIL:
      return { ...state, statsLoading: false, error: action.payload }
    case DASHBOARD.GET_APPLICANTS_STATUS_FAIL:
      return { ...state, applicantsStatusLoading: false, error: action.payload }
    case DASHBOARD.GET_APPLICANTS_REPORT_FAIL:
      return { ...state, applicantsReportLoading: false, error: action.payload }
    case DASHBOARD.GET_TOTAL_JOBS_AND_APPLICANT_FAIL:
      return {
        ...state,
        totalJobsAndApplicantLoading: false,
        error: action.payload
      }
    case DASHBOARD.GET_TOTAL_APPLICANTS_REPORTS_FAIL:
      return {
        ...state,
        totalApplicantsReportsLoading: false,
        error: action.payload
      }
    case DASHBOARD.GET_OPEN_JOB_BY_CATEGORY_FAIL:
      return {
        ...state,
        topenJobByCategoryLoading: false,
        error: action.payload
      }
    case DASHBOARD.GET_TOTAL_APPLICANTS_FUNNEL_FAIL:
      return {
        ...state,
        totalApplicantsFunnelLoading: false,
        error: action.payload
      }
    case DASHBOARD.GET_APPLICATIONS_RECEIVED_BY_CATEGORY_FAIL:
      return {
        ...state,
        applicationsReceivedByCategoryLoading: false,
        error: action.payload
      }
    case DASHBOARD.GET_JOB_POST_BY_JOB_TYPE_FAIL:
      return {
        ...state,
        jobPostByJobTypeLoading: false,
        error: action.payload
      }
    case DASHBOARD.GET_JOB_ACCEPTED_RATIO_FAIL:
      return {
        ...state,
        jobAcceptedRatioLoading: false,
        error: action.payload
      }
    case DASHBOARD.GET_JOB_BY_TITLE_FAIL:
      return {
        ...state,
        jobByTitleLoading: false,
        error: action.payload
      }
    case DASHBOARD.GET_LOCATION_DATA_FAIL:
      return {
        ...state,
        locationDataLoading: false,
        error: action.payload
      }
    case DASHBOARD.GET_APPLICANT_BY_GENDER_FAIL:
      return {
        ...state,
        applicantByGenderLoading: false,
        error: action.payload
      }

    default:
      return state
  }
}

export default dashboardReducer
